import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { COOKIE_CONSENT } from "@/constants/testIds";
import { Button } from "@/components/ui/button";

const CONSENT_KEY = "bankingfees_cookie_consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored !== "accepted") setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
    window.dispatchEvent(new Event("cookie-consent-changed"));
  };

  const dismiss = () => {
    setVisible(false);
    window.dispatchEvent(new Event("cookie-consent-changed"));
  };

  if (!visible) return null;

  return (
    <div
      data-testid={COOKIE_CONSENT.banner}
      className="fixed bottom-0 left-0 right-0 z-50 bg-[#0F1115] text-white border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex flex-wrap items-center gap-4 justify-between">
        <div className="flex items-start gap-3 max-w-2xl">
          <Cookie size={18} className="text-[#059669] mt-0.5 shrink-0" />
          <p className="text-sm text-white/70">
            We use essential cookies to run this site and basic analytics to improve it. See our{" "}
            <Link to="/cookie-policy" data-testid={COOKIE_CONSENT.policyLink} className="text-[#059669] font-semibold hover:underline">
              Cookie Policy
            </Link>{" "}
            for details.
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <Button data-testid={COOKIE_CONSENT.acceptButton} onClick={accept} className="rounded-none bg-[#059669] hover:bg-white hover:text-[#0F1115]">
            Accept
          </Button>
          <button
            data-testid={COOKIE_CONSENT.dismissButton}
            onClick={dismiss}
            aria-label="Dismiss cookie notice"
            className="text-white/50 hover:text-white transition-colors duration-150"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};
